import { Paper, Typography } from '@material-ui/core';
import {
  headingOne,
  headingThree,
  headingTwo,
  paraFive,
  paraFour,
  ParaOne,
  ParaSeven,
  paraSix,
  paraThree,
  paraTwo,
} from './constants';
import styles from './WatchListStyles';
import React from 'react';

const InfoBox = (isMobile) => {
  return (
    <Paper
      elevation={5}
      style={{ ...styles.warningPaper, width: '276px', marginTop: '0px' }}>
      <div styles={styles.warningRightSide}>
        <Typography
          variant='h6'
          component='h2'
          style={{ ...styles.warningText, fontWeight: 'bold' }}>
          {headingOne}
        </Typography>
        <Typography variant='body1' component='p' style={styles.warningText}>
          {ParaOne}
        </Typography>
        <Typography variant='body1' component='p' style={styles.warningText}>
          {paraTwo}
        </Typography>

        <Typography
          variant='h6'
          component='h2'
          style={{ ...styles.warningText, fontWeight: 'bold' }}>
          {headingTwo}
        </Typography>
        <Typography variant='body1' component='p' style={styles.warningText}>
          {paraThree}
        </Typography>
        <Typography variant='body1' component='p' style={styles.warningText}>
          {paraFour}
        </Typography>
        <Typography variant='body1' component='p' style={styles.warningText}>
          {paraFive}
        </Typography>
        <Typography
          variant='h6'
          component='h2'
          style={{ ...styles.warningText, fontWeight: 'bold' }}>
          {headingThree}
        </Typography>
        <Typography variant='body1' component='p' style={styles.warningText}>
          {paraSix}
        </Typography>
        <Typography variant='body1' component='p' style={styles.warningText}>
          {ParaSeven}
        </Typography>
      </div>
    </Paper>
  );
};

export default InfoBox;



// WEBPACK FOOTER //
// ./src/Pages/WatchList/infoBox.js